import React from "react";
import { HelpCircle, BarChart3, Info } from "lucide-react";
import { ASSETS } from "../../lib/constants";

function Header({ onHelpClick, onStatsClick, onInfoClick }) {
    return (
        <header className="clash-header">
            <div className="header-left">
                <img
                    src={ASSETS.clashLogo}
                    alt="CLASH"
                    className="header-logo"
                    onError={(e) => {
                        e.target.style.display = 'none';
                    }}
                />
            </div>

            <div className="header-center">
                <img
                    src={ASSETS.connectionsIcon}
                    alt=""
                    className="header-icon"
                />
                <span className="header-title">Connections</span>
            </div>

            <nav className="header-right">
                <button
                    className="header-btn"
                    onClick={onHelpClick}
                    aria-label="How to play"
                    title="How to play"
                >
                    <HelpCircle size={24} strokeWidth={2} />
                </button>
                <button
                    className="header-btn"
                    onClick={onStatsClick}
                    aria-label="Statistics"
                    title="Statistics"
                >
                    <BarChart3 size={24} strokeWidth={2} />
                </button>
                <button
                    className="header-btn"
                    onClick={onInfoClick}
                    aria-label="About"
                    title="About"
                >
                    <Info size={24} strokeWidth={2} />
                </button>
            </nav>
        </header>
    );
}

export default Header;
